//
//
//
//
//
//

// import { previewDataInterface } from '@/api/systemData/dataInterface'
import request from "@/utils/request";
export default {
  name: "resetting",
  props: {
    transvalue: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      visible: false,
      pageConfig: []
    };
  },
  watch: {},
  computed: {},
  created: function created() {},
  methods: {
    selects: function selects() {
      var _this = this;
      console.log("11111");
      this.$confirm("此操作将重置数据, 是否继续?", "提示", {
        type: "warning"
      }).then(function () {
        request({
          url: "/api/WMS/TableAdjustmentConfig/SetTableAdjustmentConfig",
          method: "post",
          data: {
            pageType: _this.transvalue,
            pageConfig: _this.pageConfig
          }
        }).then(function (res) {
          _this.visible = false;
          window.location.reload();
        });
      });
    }
  }
};